const smokingProcessor=(element)=>
{
let assembledElement=" smoked"
if (element["Cigarettes_/_day"]  !== "")
    {
    assembledElement  += ` ${element["Cigarettes_/_day"]} cigarettes per day`
    }

if  (element["Years_as_smoker:"] !== "")
    {
    assembledElement += ` for ${element["Years_as_smoker:"]} years`
        if  (element["Cigarettes_/_day"]  !== "")
        {
        let packYears = element["Cigarettes_/_day"] * element["Years_as_smoker:"] /20
        assembledElement += ` (${packYears} pack years)`
        }
    }

if (element["Stopped_smoking:"] === "Yes") 
    {
     if (element["Stopped_for:"] ==="")
        {
        assembledElement += " but has now stopped smoking"
        }
    else
        {
        assembledElement +=  ` but stopped smoking ${element["Stopped_for:"]} ago` 
        }
    }


return (assembledElement)
}

export default smokingProcessor